module.exports = __webpack_public_path__ + "img/no_data-cuate.acfcc68f.svg";